import { Injectable } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environment';

/**
 * Ajoute le header `X-Client-Id` sur les requêtes vers notre propre API, pour que le backend
 * sache explicitement de quelle marque provient la requête (au lieu de deviner via `Referer`,
 * peu fiable pour un client non-navigateur comme l'app mobile). Voir `Client.resolve()` côté
 * backend (`extras/models/models.py`) pour l'ordre de priorité complet.
 */
@Injectable()
export class ClientIdInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!environment.CLIENT_ID || this.shouldSkip(req.url)) {
            return next.handle(req);
        }

        return next.handle(req.clone({
            setHeaders: { 'X-Client-Id': String(environment.CLIENT_ID) }
        }));
    }

    private shouldSkip(url: string): boolean {
        const excludedPaths = [
            '/assets',
            '/github',
            '/weather',
            'netbox/api',
        ];

        if (environment.KEYCLOAK_URL && url.includes(environment.KEYCLOAK_URL)) {
            return true;
        }

        return excludedPaths.some(path => url.includes(path));
    }
}

export const clientIdInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: ClientIdInterceptor, multi: true }
];
